import { render, staticRenderFns } from "./subsidiaryInformation.vue?vue&type=template&id=0df71260&scoped=true&"
import script from "./subsidiaryInformation.vue?vue&type=script&lang=js&"
export * from "./subsidiaryInformation.vue?vue&type=script&lang=js&"
import style0 from "./subsidiaryInformation.vue?vue&type=style&index=0&id=0df71260&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df71260",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0df71260')) {
      api.createRecord('0df71260', component.options)
    } else {
      api.reload('0df71260', component.options)
    }
    module.hot.accept("./subsidiaryInformation.vue?vue&type=template&id=0df71260&scoped=true&", function () {
      api.rerender('0df71260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/subsidiaryInformation.vue"
export default component.exports